import { Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { PRIVATE_PAGES } from "@app/router/pages";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import BasicPagination from "@app/components/Pagination";

import { StyledTableCell } from "./styled";
import { useFaqListLogic } from "./useFaqListLogic";

const Faqs = () => {
  const {
    faqList,
    pagesCount,
    handleDeleteFaq,
    handlePagination
  } = useFaqListLogic()

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '20px',
        flexDirection: 'column',
        alignItems: 'flex-end'
      }}
    >
      <Box display="flex" gap={1}>
        <Link to={PRIVATE_PAGES.UPDATE_FAQ_ORDERING}>
          <Button variant="contained" color="primary">
            Change Ordering
          </Button>
        </Link>
        <Link to={PRIVATE_PAGES.CREATE_FAQS}>
          <Button variant="contained" color="primary">
            Create FAQ
          </Button>
        </Link>
      </Box>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Question En</TableCell>
              <TableCell align="center">Question Ru</TableCell>
              <TableCell align="center">Question AM</TableCell>
              <TableCell align="center">Answer En</TableCell>
              <TableCell align="center">Answer Ru</TableCell>
              <TableCell align="center">Answer AM</TableCell>
              <TableCell align="center">ACTIONS</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {faqList.map((faq) => {
              return (
                <TableRow key={faq.id}>
                  <TableCell align="center">{faq.questionAm}</TableCell>
                  <TableCell align="center">{faq.questionEn}</TableCell>
                  <TableCell align="center">{faq.questionRu}</TableCell>
                  <TableCell align="center">{faq.answerAm}</TableCell>
                  <TableCell align="center">{faq.answerEn}</TableCell>
                  <TableCell align="center">{faq.answerRu}</TableCell>
                  <StyledTableCell align="center">
                    <Link to={`/faq/${faq.id}`}>
                      <Button variant="outlined">
                        Edit
                      </Button>
                    </Link>
                    <Button variant="contained" onClick={() => handleDeleteFaq(faq.id)}>
                      Delete
                    </Button>
                  </StyledTableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <BasicPagination count={pagesCount} callback={handlePagination} />
    </Box>
  )
};

export default Faqs;
